<template>
    <div>
        <fade-in v-if="type === 'fade-in'">
            <slot></slot>
        </fade-in>

        <fade-in-up v-if="type === 'fade-in-up'">
            <slot></slot>
        </fade-in-up>
    </div>
</template>

<script>
import fadeIn from './animations/legacy/fadeInLegacy.vue';
import fadeInUp from './animations/legacy/fadeInUpLegacy.vue';

export default {
    components: {
        fadeIn,
        fadeInUp
    },

    props: {
        type: String,
        delay: String,
        repeat: Boolean
    },

    data() {
        return {
            scrollcontrol: new ScrollMagic.Controller(),
            windowHalfY: window.innerHeight / 2
        };
    }
};
</script>
